import React, { PropsWithChildren } from 'react';
import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material';

type IconButtonProps = PropsWithChildren<MuiIconButtonProps>;

const IconButton: React.FC<IconButtonProps> = ({
  sx,
  children,
  ...otherProps
}) => {
  return (
    <MuiIconButton
      disableRipple
      sx={{
        padding: '4px',
        margin: 0,
        borderRadius: '4px',
        ':hover': {
          background: 'var(--dk-bg-muted, #F3F5F6)',
        },
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </MuiIconButton>
  );
};

export default IconButton;
